import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Container, Heading, Text, Stack } from '@chakra-ui/react';

function CallToAction() {
  const navigate = useNavigate();
  return (
    <Stack
      spacing={4}
      as={Container}
      maxW={'6xl'}
      py={12}
      textAlign={'center'}
      align={{ base: 'stretch', md: 'center' }}
    >
      <Heading fontSize={'3xl'}>
        Nurturing Confident and Creative Writers
      </Heading>
      <Text color={'gray.600'} fontSize={'xl'}>
        Ivy inspires a love for writing, critical thinking, and authentic
        self-expression. Together, let’s build confident, capable writers!
      </Text>
      <Button
        w="auto"
        rounded={'full'}
        size={'lg'}
        fontWeight={'normal'}
        px={6}
        colorScheme={'red'}
        bg={'green.400'}
        _hover={{ bg: 'green.500' }}
        onClick={() => navigate('/pricing')}
      >
        Start Writing Now
      </Button>
    </Stack>
  );
}

export default CallToAction;
